
export interface TransactionHistoryDto
{
    getMsisdn(): string;
    getFromDate():string;
    getToDate():string;
    getId(): string;
    getTimeStamp(): string;
    getPrice(): string;
    getTitle(): string;
    getDuration(): string;
    getEnglishToneName(): string;
    getSubscriptionDate(): string;
    getTransactionType(): string;
    getChannel(): string;

}

export class TransactionHistoryDtoImpl implements TransactionHistoryDto
{
   
    private msisdn: string;
    private fromDate: string;
    private toDate: string;
    private id: string;
    private timestamp: string;
    private price: string;
    private title: string;
    private transactionType: string;
    private channel: string;
    private englishToneName: string;
    private duration: string;
    private subscriptionDate: string;

    setDuration(duration: string)
    {
        this.duration = duration;
    }
    getMsisdn(): string 
    {
        return this.msisdn;
    }
    setMsisdn(msisdn: string)
    {
        this.msisdn = msisdn;
    }

    getFromDate(): string 
    {
        return this.fromDate;
    }
    setFromDate(fromDate: string)
    {
        this.fromDate = fromDate;
    }

    getToDate(): string 
    {
        return this.toDate;
    }
    setToDate(toDate: string)
    {
        this.toDate = toDate;
    }
    getDuration(): string {
        return this.duration;
    }
    getId(): string 
    {
        return this.id;
    }    
    getTimeStamp(): string 
    {
       return this.timestamp;
    }

    getPrice(): string 
    {
        return this.price;
    }

    getTitle(): string 
    {
        return this.title;
    }

    getTransactionType(): string 
    {
        return this.transactionType;
    }

    getChannel(): string 
    {
        return this.channel;
    }

    setId(id: string)
    {
        this.id = id;
    }

    setTimeStamp(timestamp: string)
    {
        this.timestamp = timestamp;
    }

    setTitle(title: string)
    {
        this.title = title;
    }

    setTransactionType(type: string)
    {
        this.transactionType = type;
    }

    setPrice(price: string)
    {
        this.price = price;
    }

    setChannel(channel: string)
    {
        this.channel = channel;
    }

    getSubscriptionDate(): string 
    {
        return this.subscriptionDate;
    }
    setSubscriptionDate(subscriptionDate: string)
    {
        this.subscriptionDate = subscriptionDate;
    }

    getEnglishToneName(): string 
    {
        return this.englishToneName;
    }
    setEnglishToneName(englishToneName: string)
    {
        this.englishToneName = englishToneName;
    }
}


// WEBPACK FOOTER //
// ./src/com/sixdee/crbtportal/core/dto/transactionhistory/transactionhistorydto.tsx